import "./PropertyName.css";

import { Badge } from "reactstrap";
import { HighlightedText } from "../highlightedText/HighlightedText";
import PropTypes from "prop-types";
import { selectTraitsIndexedOnTechnicalName } from "../../selectors/traits";
import { useGetPropertyCategory } from "../../hooks/useGetPropertyCategory";
import { useSelector } from "react-redux";

export const PropertyName = ({
  className,
  technicalName,
  highlight = "",
  showIcon,
  showUnit,
  hideName,
  colorful,
}) => {
  const traitsObject = useSelector(selectTraitsIndexedOnTechnicalName);
  const getPropertyCategory = useGetPropertyCategory();

  // Base name can have date concatenated with @
  const [baseName, date] = technicalName.split("@");
  const category = getPropertyCategory(baseName);

  const splitted = baseName.split("|");
  const prefix = splitted.shift();
  const classes = splitted.map((label) => label.replaceAll("_", " "));

  const trait = traitsObject[prefix];
  const name = trait?.name ?? prefix;
  const unit = (showUnit && trait?.unit && ` (${trait.unit})`) ?? "";

  return (
    <span
      className={`property-name ${category.className} ${
        className ? className : ""
      }`}
      title={`${name} ${classes.join(" ")}${unit}`}
      style={{ color: colorful && category.color }}
    >
      {showIcon && category.icon}{" "}
      {!hideName && (
        <>
          <HighlightedText text={name} highlight={highlight} />
          {classes.map((label) => (
            <Badge
              className="ms-1 class-badge"
              key={label}
              color="Invalid color"
              style={{
                border: `1px solid ${category.color}`,
                color: category.color,
              }}
            >
              <HighlightedText text={label} highlight={highlight} />
            </Badge>
          ))}
          {unit}
          {date && (
            <Badge
              className="ms-1 class-badge"
              color="Invalid color"
              style={{
                border: `1px solid ${category.color}`,
                color: category.color,
              }}
            >
              <i className="fa-solid fa-calendar-days me-1" />
              <HighlightedText text={date} highlight={highlight} />
            </Badge>
          )}
        </>
      )}
    </span>
  );
};

PropertyName.propTypes = {
  technicalName: PropTypes.string.isRequired,
  className: PropTypes.string,
  highlight: PropTypes.string,
  showIcon: PropTypes.bool,
  showUnit: PropTypes.bool,
  hideName: PropTypes.bool,
  colorful: PropTypes.bool,
};
